import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

export const Layout = () => {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-background relative">
      <div className="noise-overlay" />
      {!isAdmin && <Navbar />}
      <main>
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatWidget />}
    </div>
  );
};

export default Layout;
